import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { DataTable } from "@/components/DataTable";
import { ROLE_LABELS, ROLES } from "@/lib/roles";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name:"", email:"", password:"", role:"faculty", phone:"" });
  const load = async () => setUsers((await api.get("/users")).data);
  useEffect(()=>{load()},[]);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/register", form);
      setOpen(false);
      setForm({ name:"", email:"", password:"", role:"faculty", phone:"" });
      toast.success("User created"); load();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    }
  };

  return (
    <div>
      <PageHeader title="Users & Roles" subtitle="Manage platform accounts and access"
        actions={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><button className="btn-primary" data-testid="add-user-btn">+ New user</button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Create user</DialogTitle></DialogHeader>
              <form onSubmit={create} className="space-y-3">
                <input required placeholder="Full name" data-testid="user-name-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.name} onChange={e=>setForm({...form, name:e.target.value})}/>
                <input required type="email" placeholder="Email" data-testid="user-email-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.email} onChange={e=>setForm({...form, email:e.target.value})}/>
                <input required type="password" placeholder="Temporary password" data-testid="user-password-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.password} onChange={e=>setForm({...form, password:e.target.value})}/>
                <input placeholder="Phone" data-testid="user-phone-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.phone} onChange={e=>setForm({...form, phone:e.target.value})}/>
                <select data-testid="user-role-select" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md bg-white" value={form.role} onChange={e=>setForm({...form, role:e.target.value})}>
                  {Object.values(ROLES).map(r => <option key={r} value={r}>{ROLE_LABELS[r]}</option>)}
                </select>
                <DialogFooter><button className="btn-primary" data-testid="user-save-btn">Create</button></DialogFooter>
              </form>
            </DialogContent>
          </Dialog>
        }
      />
      <DataTable
        testid="users-table"
        columns={[
          { key:"name", label:"Name", render: r => (
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-[#EAF3FB] text-[#0A66C2] flex items-center justify-center text-xs font-semibold">{r.name?.[0]}</div>
              <div>
                <div className="font-semibold">{r.name}</div>
                <div className="text-xs text-[#00000099]">{r.email}</div>
              </div>
            </div>
          )},
          { key:"role", label:"Role", render: r => <span className="text-[11px] px-2 py-0.5 rounded bg-[#EAF3FB] text-[#0A66C2] font-semibold uppercase tracking-wider">{ROLE_LABELS[r.role] || r.role}</span> },
          { key:"phone", label:"Phone" },
          { key:"created_at", label:"Created", render: r => r.created_at ? new Date(r.created_at).toLocaleDateString() : "—" },
        ]}
        rows={users}
      />
    </div>
  );
}
